import React from 'react';
import { ToggleButtonGroup, ToggleButton, Tooltip } from '@mui/material';
import {
    ViewModule as ViewModuleIcon,
    ViewList as ViewListIcon,
} from '@mui/icons-material';

export type ViewMode = 'cards' | 'table';

interface ViewToggleProps {
    value: ViewMode;
    onChange: (mode: ViewMode) => void;
}

const ViewToggle: React.FC<ViewToggleProps> = ({ value, onChange }) => (
    <ToggleButtonGroup
        value={value}
        exclusive
        onChange={(_e, newValue) => newValue && onChange(newValue)}
        size="small"
    >
        <ToggleButton value="cards">
            <Tooltip title="Karty">
                <ViewModuleIcon fontSize="small" />
            </Tooltip>
        </ToggleButton>
        <ToggleButton value="table">
            <Tooltip title="Tabulka">
                <ViewListIcon fontSize="small" />
            </Tooltip>
        </ToggleButton>
    </ToggleButtonGroup>
);

export default ViewToggle;
